import React from "react";
import "./VerticalNavItem.css";

export function VerticalNavItem({
  active,
  dividerActive,
  text,
  number,
  onClick,
  last,
}: {
  active: boolean;
  dividerActive: boolean;
  text: string;
  number: number;
  onClick: () => void;
  last: boolean;
}) {
  return (
    <div className="nav-item">
      <div className="flex items-center pointer" onClick={onClick}>
        <div
          className={`status ${
            active ? "active" : ""
          } flex justify-center items-center mr-2`}
        >
          {number}
        </div>
        <div className="text">{text}</div>
      </div>
      {last ? null : (
        <div className={`divider ${dividerActive ? "active" : ""}`} />
      )}
    </div>
  );
}
